export enum SubscriptionPolicy {
  optIn = 'OptIn',
  optOut = 'OptOut',
  doubleOptIn = 'DoubleOptIn',
}

export type MessageType = {
  id: number;
  createdAt: number;
  updatedAt: number;
  projectId: number;
  name: string;
  messageChannelId: number;
  subscriptionPolicy: SubscriptionPolicy;
};
